








import Vue from 'vue'
import BooleanColumn from '@/components/DataTable/Columns/Common/BooleanColumn.vue'

interface Props {
  columnValue: string
  columnName: string
  directory: string
}

export default Vue.extend<{}, {}, {}, Props>({
  components: {
    BooleanColumn,
  },
  props: {
    columnValue: {
      required: true,
    },
    columnName: {
      required: true,
    },
    directory: {
      required: true,
    },
  },
})
